import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import reportWebVitals from "./reportWebVitals";
import { createBrowserRouter, RouterProvider } from "react-router-dom";
import { Login } from "./pages/Login";
import { Swaps } from "./pages/Swaps";
import { AuthProvider, RequireAuth } from "./AuthProvider";
import { GqlProvider } from "./GqlProvider";
import { ResetPassword } from "./pages/ResetPassword";
import { User } from "./pages/User";
import { Logs } from "./pages/Logs";
import { NotFound } from "./pages/Notfound";
import { Organization } from "./pages/Organization";
import { Organizations } from "./pages/Organizations";
import { Swap } from "./pages/Swap";
import { Settings } from "./pages/Settings";
import Failures from "./pages/Failures";

const router = createBrowserRouter([
  {
    path: "/",
    element: (
      <RequireAuth>
        <Organizations />
      </RequireAuth>
    ),
  },
  {
    path: "/organizations/:id",
    element: (
      <RequireAuth>
        <Organization />
      </RequireAuth>
    ),
  },
  {
    path: "/swaps",
    element: (
      <RequireAuth>
        <Swaps />
      </RequireAuth>
    ),
  },
  {
    path: "/swap/:id",
    element: (
      <RequireAuth>
        <Swap />
      </RequireAuth>
    ),
  },
  {
    path: "/user/:id",
    element: (
      <RequireAuth>
        <User />
      </RequireAuth>
    ),
  },
  {
    path: "/logs",
    element: (
      <RequireAuth>
        <Logs />
      </RequireAuth>
    ),
  },
  {
    path: "/failures",
    element: (
      <RequireAuth>
        <Failures />
      </RequireAuth>
    ),
  },
  {
    path: "/login",
    element: <Login />,
  },
  {
    path: "/reset-password/:token",
    element: <ResetPassword />,
  },
  {
    path: "/settings",
    element: <Settings />,
  },
  // not found
  {
    path: "*",
    element: <NotFound />,
  },
]);

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <AuthProvider>
      <GqlProvider>
        <RouterProvider router={router} />
      </GqlProvider>
    </AuthProvider>
  </React.StrictMode>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
